const API = process.env.REACT_APP_API_URL ?? "http://localhost:5000";

async function post(path, body) {
  try {
    const res = await fetch(`${API}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
    return await res.json();
  } catch (e) {
    console.error("API error", path, e);
    return { ok: false, error: e.message };
  }
}

// Send SMS via iProg
export const sendSMS = (phone, message) => post("/api/sms/send", { phone, message });

// Send email via Gmail SMTP
export const sendEmail = (to, subject, html) => post("/api/email/send", { to, subject, html });

// AI grammar reconstruction (Anthropic Claude)
export const fixGrammar = (text) => post("/api/ai/grammar", { text });

// AI chatbot — uses context info you feed later
export const chatbotAsk = (question, history = []) => post("/api/ai/chatbot", { question, history });

// Live chat — look up applicant by Endorsement ID (auto-fills name/address)
export const chatLookup = (applicationId) => post("/api/chat/lookup", { applicationId });

// Live chat — applicant sends a message to the agency team
export const chatSend = (applicantId, applicationId, name, address, text) =>
  post("/api/chat/send", { applicantId, applicationId, name, address, text });

// Live chat — fetch saved conversation messages
export const chatMessages = (applicantId) => post("/api/chat/messages", { applicantId });

// Notify admin of new endorsement request
export const notifyAdminOfApplication = (applicantName, applicationId) =>
  post("/api/notifications/new-application", { applicantName, applicationId });

// Notify status updates
export const notifyStatus = (phone, email, applicantName, statusMessage) =>
  post("/api/notifications/status", { phone, email, applicantName, statusMessage });

// Notify rejection with reason
export const notifyRejected = (phone, email, applicantName, reason) =>
  post("/api/notifications/rejected", { phone, email, applicantName, reason });
